import { track } from "../analytics"
import type { Auth0ContextInterface } from '@auth0/auth0-react';

const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export async function auth0QueryFunction<TResponse>(path: string, getAccessTokenSilently: Auth0ContextInterface['getAccessTokenSilently'], loginWithRedirect: Auth0ContextInterface['loginWithRedirect'], audience: string, scope: string) {
  const url = `${origin}/api/${path}`

  // Try getting the token silently
  let accessToken = ''
  try {
    accessToken = await getAccessTokenSilently({ audience, scope })
  } catch (e) {
    console.warn('getAccessTokenSilently() useapiquery FAILED, redirecting to login…', e)
    await loginWithRedirect({
      appState: { returnTo: window.location.pathname + window.location.search }
    })
    throw new Error('Authentication required')
  }

  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })

  if (res.ok) {
    try {
      const jsonResponse = await res.json()
      console.log('useApiTanstack', { path, jsonResponse })
      return jsonResponse as TResponse
    } catch (e) {
      // Handle empty response
      track('error', 'useApiTanstack', {}, {
        message: 'Empty success response, returning empty object',
        error: JSON.stringify(e),
      })
      return {} as TResponse
    }
  } else {
    let errorData: any = null
    try {
      errorData = await res.json()
    } catch (e) {
      track('error', 'useApiTanstack', {}, {
        message: 'Failed to parse error response as JSON',
        error: JSON.stringify(e),
      })
      errorData = { userErrorMessage: 'An error occurred' }
    }
    throw errorData
  }
}
